import {useMutation, useQueryClient} from "@tanstack/react-query";
import {notification} from "antd";
import {useTranslation} from "react-i18next";
import {depositPagoMovilService} from "../../services/wallet/deposit.service";

const useDepositPagoMovil = () => {
  const {t} = useTranslation();
  const queryClient = useQueryClient();
  const {isError, isPending, isSuccess, refetch, error, mutate, status} = useMutation({
    mutationKey: ["postDepositTopUp"],
    mutationFn: depositPagoMovilService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWalletDeposit"]});
      notification.success({
        message: t("depositInstructionsBankTitle"),
        description: t("depositInstructionsBankSuccess"),
      });
    },
    onError: _error => {
      queryClient.invalidateQueries({queryKey: ["userWalletDeposit"]});
      notification.warning({
        message: t("depositInstructionsBankWarning"),
        description: t("depositInstructionsBankError"),
      });
    },
  });

  return {isError, isPending, refetch, isSuccess, error, mutate, status};
};

export default useDepositPagoMovil;
